export default "__VITE_ASSET__90f196c6__"